{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/term-count",
	"title": "Term Count",
	"category": "theme",
	"description": "Displays the post count of a taxonomy term.",
	"textdomain": "default",
	"usesContext": [ "termId", "taxonomy", "termData" ],
	"attributes": {
		"bracketType": {
			"type": "string",
			"enum": [ "none", "round", "square", "curly", "angle" ],
			"default": "round"
		}
	},
	"supports": {
		"anchor": true,
		"html": false,
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"gradient": true
		},
		"color": {
			"gradients": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"shadow": true,
		"spacing": {
			"margin": true,
			"padding": true
		},
		"dimensions": {
			"minHeight": true,
			"minWidth": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"textAlign": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true,
			"__experimentalDefaultControls": {
				"color": true,
				"width": true,
				"style": true
			}
		}
	},
	"style": "wp-block-term-count"
}
